import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

import * as moment from 'moment';
import { AccountSummaryComponent } from '../account-summary/account-summary.component';
import { Subscription } from 'rxjs/Subscription';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import { BASE64_LOGO } from '../../shared/pdf-logo-base64';
declare var pdfMake: any;

import { AuthGuardService, LoadingService, UserService } from '@core/services';
import { User, TripHistoryDatabase } from '@shared/models';

import { fadeAnimation } from '../../app.animations';

@Component({
  selector: 'app-account-detail',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.css'],
  providers: [AccountSummaryComponent],
  animations: [fadeAnimation]
})
export class AccountDetailComponent implements OnInit, OnDestroy {

  user: User;
  id: number;
  subscription: Subscription;
  tripDetailSubscription: Subscription;
  private pdf: any;
  public showLoader = true;

  private routeSubscription: Subscription;
  //public startDate: any = moment().subtract(1, 'months').format('YYYY-MM-DD');
  //public endDate: any = moment().format('YYYY-MM-DD');
  // replaced with javascript dates because mat-datepicker was using javascript native dates by default.
  // using moment dates was causing dates to be a day off.
  public startDate: any;
  public endDate: any;
  private tripCost = '';
  rawAccountDetails: any;
  accountTripDatabase: TripHistoryDatabase;
  dataSource;
  private accountDetailFlagSubscription: Subscription;

  displayedColumns = ['tripDate', 'tripTime', 'tripLane', 'tripFare', 'tripCardNumber', 'tripName'];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(private _userService: UserService,
    private route: ActivatedRoute,
    private _router: Router,
    private _authGuard: AuthGuardService,
    private _loadingService: LoadingService) {

  }

  ngOnInit() {
    // set start and end dates of date pickers
    this.startDate = new Date();
    this.endDate = new Date();
    this.startDate.setMonth(this.startDate.getMonth() - 1);

    this.subscription = this._userService.getUser().subscribe(user => {
      this.user = user;
    });

    this.tripDetailSubscription = this._userService.getTripDetailDatabase().subscribe(tripDatabase => {
      this.accountTripDatabase = tripDatabase;
      console.log(this.accountTripDatabase.data);
      if (this.paginator) this.paginator.length = this.accountTripDatabase.data.length;
      this.dataSource = new MatTableDataSource(this.accountTripDatabase.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      console.log("datasource: ....");
      console.log(this.dataSource);
    });

    this.accountDetailFlagSubscription = this._authGuard.getDetailsFlag().subscribe(detailsFlag => {
      this.showLoader = detailsFlag;
    });

    this.routeSubscription = this.route.params.subscribe(params => {
      if (params['id'] > 0)
        this.id = +params['id']; // (+) converts string 'id' to a number
      this.dataSource.filter = String(this.id);
    });

  }

  ngAfterViewInit() {

    if(this.accountTripDatabase){ //load old data if exists
      this.paginator.length = this.accountTripDatabase.data.length || 0;
      this.dataSource = new MatTableDataSource(this.accountTripDatabase.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.tripDetailSubscription) {
      this.tripDetailSubscription.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.accountDetailFlagSubscription) {
      this.accountDetailFlagSubscription.unsubscribe();
    }
  }

  onChange() {
    this._authGuard.getAccountDetails(this.user.customerIdArray[this.user.customerIndex].Id, this.startDate, this.endDate);
    //this.paginator.length = this.accountTripDatabase.data.length;
  }

  onAccountChange(accountIndex) {
    // this._router.navigateByUrl('/accountdetail/' + this.user.accountSummaryArray[accountIndex].id);
    this.dataSource.filter = String(this.user.accountSummaryArray[accountIndex].id);
  }

  dollarFormat(paymentAmount: number) {
    return paymentAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  getTimeFormat(tripDate: string) {
    const tripDateArray = tripDate.split(' ');
    const tripTime = tripDateArray[1] + ' ' + tripDateArray[2];
    return tripTime;
  }

  getDateFormat(tripDate: string) {
    const tripDateArray = tripDate.split(' ');
    tripDate = tripDateArray[0];
    console.log(tripDate);
    tripDate = moment(tripDate, 'MM-DD-YYYY').format("MM/DD/YYYY");
    console.log(tripDate);
    return tripDate;

  }


  downloadTripHistoryCSV() {
    var data = new Array();
    data.push({ title: "Trip History" });
    data.push({ col1: "Trip Number", col2: "Account Number", col3: "Date", col4: "Time", col5: "Lane", col6: "Fare Paid", col7: "Card Number", col8: "Card Name" });

    for (let trip of this.accountTripDatabase.data) {
      console.log(trip);
      data.push({ index: +trip.index + 1, id: trip.id, date: trip.date, time: trip.time, lane: trip.lane, farePaid: trip.farePaid, cardNumber: trip.cardNumber, name: trip.name });
    }

    new Angular2Csv(data, 'Trip History Report');
  }

  downloadTripHistoryPDF() {
    this.pdf = pdfMake;
    var dateStartDate = new Date(this.startDate)
    var dateEndDate = new Date(this.endDate)
    var strStartDate = 'Y_m_d'
      .replace('Y', String(dateStartDate.getFullYear()))
      .replace('m', String(dateStartDate.getMonth()+1))
      .replace('d', String(dateStartDate.getDate()));
    var strEndDate = 'Y_m_d'
      .replace('Y', String(dateEndDate.getFullYear()))
      .replace('m', String(dateEndDate.getMonth()+1))
      .replace('d', String(dateEndDate.getDate()));
    this.pdf.createPdf(this.buildPdf()).download('Detroit_Windsor_Tunnel-Trip_History-' + strStartDate  + '-' + strEndDate + '.pdf');
  }

  buildPdf() {
    const docDefinition = {
      footer:
      [
      ]
      ,
      content: [
        {
          margin: [0, 10],
          columns: [{
            image: BASE64_LOGO,
            width: 128
          },
          ],
        },
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 5,
              x2: 595 - 2 * 40, y2: 5,
              lineWidth: .5, color: '#666666'
            }
          ], alignment: 'center', margin: [0, 0, 0, 10]
        },
        {
          table: {
            body: [
              ['Date', 'Time', 'Lane', 'Fare Paid', 'Card #', 'Name']
            ],
          },
          layout: 'noBorders',
          margin: [0, 20, 0, 20]

        },
        { canvas: [{ type: 'line', x1: 0, y1: 5, x2: 595 - 2 * 40, y2: 5, lineWidth: .5, color: '#666666' }], alignment: 'center', margin: [0, 20, 0, 10] }, {
          text: 'Copyright ' + new Date().getFullYear() + ' DWTunnel. All rights reserved.'
        },
      ],
    }
    for(let trip of this.accountTripDatabase.data){
      docDefinition.content[2]['table']['body'].push([trip.date, trip.time, trip.lane, this.dollarFormat(+trip.farePaid), trip.cardNumber, trip.name])

    }
    return docDefinition;
  }


}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/account-detail/account-detail.component.ts